import React from 'react';
import { Navigate } from 'react-router-dom';

import 'index.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import 'locales/i18n';

import useQueryProfileInfo from 'common/layouts/Default/hooks/queries/useQueryProfileInfo';
import MainRoutes from 'routes/Main';
import { useAuthState } from 'services/auth/AuthContext';
import SettingsNavigationProvider from 'services/settings/navigation';

const App = () => {
  const {
    state: { isAuthenticated },
  } = useAuthState();

  //Query hooks
  const { isLoadingProfileInfo, errProfileInfo, profileInfo } =
    useQueryProfileInfo(isAuthenticated);

  if (isLoadingProfileInfo) {
    return null;
  }
  if (errProfileInfo) {
    return <Navigate to="/404" />;
  }

  return (
    <SettingsNavigationProvider profileInfo={profileInfo}>
      <MainRoutes profileInfo={profileInfo} />
    </SettingsNavigationProvider>
  );
};

export default App;
